import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface LanguageSelectProps {
  title: string;
  selectedLanguage: string;
  onLanguageChange: (lang: string) => void;
  onStart: () => void;
  onClose?: () => void;
}

export function LanguageSelect({
  title,
  selectedLanguage,
  onLanguageChange,
  onStart,
  onClose,
}: LanguageSelectProps) {
  const [localLanguage, setLocalLanguage] = useState(selectedLanguage);

  const handleStart = () => {
    onLanguageChange(localLanguage); // update parent state
    onStart(); // close modal / start exam
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6 w-full max-w-md select-none">
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
          >
            ✕
          </button>
        )}

        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">{title}</h1>

        <div className="flex flex-col items-center gap-2 mb-6">
          <label>Select Language:</label>
          <select
            value={localLanguage}
            onChange={(e) => setLocalLanguage(e.target.value)}
            className="border rounded p-2 bg-background text-foreground w-full"
          >
            <option value="en">English</option>
            <option value="gu">Gujarati</option>
          </select>
        </div>

        <div className="flex flex-col gap-2">
          <Button className="gcep-primary-btn w-full" onClick={handleStart}>
            Start Exam
          </Button>

          {onClose && (
            <Button variant="secondary" onClick={onClose} className="w-full">
              <ArrowLeft size={16} className="mr-2" /> Back
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
